import api from './api';

export const driverReportsApi = {
  getAllDrivers: () => api.get('/api/driver-reports/drivers'),
  getReport: (driverId, startDate, endDate) => 
    api.get(`/api/driver-reports/report?driver_id=${driverId}&start_date=${startDate}&end_date=${endDate}`),
  getMonthReport: (driverId, year, month) => 
    api.get(`/api/driver-reports/report/month?driver_id=${driverId}&year=${year}&month=${month}`),
};
